import {
    ArnPayloadType,
    NewPurchasePayload,
} from '../../components/dashboard/commercial/ExploreMFs/types';
import { CALL_API, ResponseBody } from '../middleware';
import {
    CHECK_ONLINE_PAYMENT_MODE,
    GET_EKYC_NEW_STATUS,
    GET_EKYC_NEW_STATUS_FAILED,
    GET_EKYC_NEW_STATUS_SUCCESS,
    GET_MASTER_DATA,
    GET_MASTER_DATA_SUCCESS,
    GET_OTM_BANK_DETAILS,
    GET_BANK_DETAILS,
    GET_BANK_DETAILS_SUCCESS,
    GET_BANK_DETAILS_FAILED,
    GET_OTM_BANK_DETAILS_FAILED,
    GET_OTM_BANK_DETAILS_SUCCESS,
    GET_OTM_DETAILS,
    GET_OTM_DETAILS_SUCCESS,
    GET_PAYMENT_STATUS,
    GET_PAYMENT_STATUS_FAILED,
    GET_PAYMENT_STATUS_SUCCESS,
    GET_PURCHASE_DETAILS,
    GET_PURCHASE_DETAILS_SUCCESS,
    GET_PURCHASE_SCHEME_DETAILS,
    GET_PURCHASE_SCHEME_DETAILS_FAILED,
    GET_PURCHASE_SCHEME_DETAILS_SUCCESS,
    NEW_PURCHASE,
    NEW_PURCHASE_SUCCESS,
    OtmAllowedBankAPIReq,
    OtmAllowedBankAPIResponse,
    OtmPayload,
    OtmTrxnRequestType,
    PaymentStatusResponse,
    PaymentStausApiRequestType,
    PENNY_DROP_SUCCESS,
    PERFORM_PENNY_DROP,
    PROSPECT_FOLIO,
    PROSPECT_FOLIO_SUCCESS,
    REGISTER_NEW_OTM,
    REGISTER_NEW_OTM_FAILED,
    REGISTER_NEW_OTM_SUCCESS,
    ResponseStatus,
    TRANSACTION_PAY_ONLINE,
    TRANSACTION_PAY_ONLINE_FAILED,
    TRANSACTION_PAY_ONLINE_SUCCESS,
    VALIDATE_ARN,
    VALIDATE_ARN_SUCCESS,
    GetAllowedBanksRequest,
} from '../types/newPurchase';
import {
    GET_FATCA_STATUS,
    GET_FATCA_STATUS_FAILED,
    GET_FATCA_STATUS_SUCCESS,
    GET_KYC_VERIFIED,
    GET_KYC_VERIFIED_FAILED,
    GET_KYC_VERIFIED_SUCCESS,
    IsAllow,
    PAN_SEED_CHECK,
    PAN_SEED_CHECK_SUCCESS,
} from '../types/portfolio';
import store from '../../store';
import { FatcaCheckResponseType } from '../../components/common/FatcaCheck.types';
import { RegisterOtmReqType } from '../../components/dashboard/commercial/emandate/types';
import {
    PanSeedActionType,
    PanSeedCheckRequestDataType,
    PanSeedCheckResponseType,
} from '../../components/common/types';
import { Dispatch } from 'react';
import { DispatchProp } from 'react-redux';

export const getPurchaseDetails =
    (body: any) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/user/getUnclaimedPayouts`,
                        method: 'POST',
                        types: [GET_PURCHASE_DETAILS_SUCCESS, GET_PURCHASE_DETAILS],
                        body,
                        // enableFixture: true,
                        // json: `unclaimedPayout.json`,
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const getMasterFunds =
    () =>
        async (dispatch: any): Promise<any> => {
            const { newPurchase } = store.getState();
            const { exploreSchemeDataStatus } = newPurchase;
            if (
                exploreSchemeDataStatus === ResponseStatus.PENDING ||
                exploreSchemeDataStatus === ResponseStatus.DONE
            )
                return;
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/feed/schemeMaster `,
                        method: 'POST',
                        types: [
                            GET_PURCHASE_SCHEME_DETAILS_SUCCESS,
                            GET_PURCHASE_SCHEME_DETAILS,
                            GET_PURCHASE_SCHEME_DETAILS_FAILED,
                        ],
                        // enableFixture: true,
                        json: `test.json`,
                    },
                });
            } catch (error: any) {
                alert(error.message);
            }
        };

export const getMasterData =
    () =>
        async (dispatch: any): Promise<any> => {
            const { newPurchase } = store.getState();
            const { masterDataApiStatus } = newPurchase;
            if (
                masterDataApiStatus === ResponseStatus.PENDING ||
                masterDataApiStatus === ResponseStatus.DONE
            )
                return;
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/feed/master',
                        method: 'POST',
                        types: [GET_MASTER_DATA_SUCCESS, GET_MASTER_DATA],
                        // enableFixture: true,
                        // json: `masterData.json`,
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const makeNewPurchase =
    (body: NewPurchasePayload) =>
        async (dispatch: any): Promise<any> => {
            const { newPurchase } = store.getState();
            const {
                kycVerified: { value },
            } = newPurchase;
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/newPurchase',
                        method: 'POST',
                        types: [NEW_PURCHASE_SUCCESS, NEW_PURCHASE],
                        body: {
                            data: [
                                {
                                    ...body,
                                    // kycStatus: value === null ? IsAllow.No : value
                                },
                            ],
                            reqId: '123',
                        },
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const makeAdditionalPurchase =
    (body: any) =>
        async (dispatch: any): Promise<any> => {
            try {
                const { newPurchase } = store.getState();
                const {
                    kycVerified: { value },
                } = newPurchase;
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/additionalPurchase',
                        method: 'POST',
                        types: [NEW_PURCHASE_SUCCESS, NEW_PURCHASE],
                        body: {
                            ...body,
                            data: [
                                {
                                    ...((body?.data || [])[0] || {}),
                                    // kycStatus: value === null ? IsAllow.No : value,
                                },
                            ],
                        },
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const validateArn =
    (body: ArnPayloadType) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/user/validateArnRiaDetail',
                        method: 'POST',
                        types: [VALIDATE_ARN_SUCCESS, VALIDATE_ARN],
                        body: { data: [body] },
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const getOtmData =
    (body: OtmPayload) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/user/getOtmDetail',
                        method: 'POST',
                        types: [GET_OTM_DETAILS_SUCCESS, GET_OTM_DETAILS],
                        body,
                        enableFixture: false,
                        json: 'OtmDetails.json',
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const checkOnlinePayment =
    (body: any) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/checkOnlinePayment',
                        method: 'POST',
                        body,
                        types: [CHECK_ONLINE_PAYMENT_MODE],
                        // enableFixture: true,
                        // json: 'checkOnlinePayment.json',
                        // enableForProduction: true,
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const trxnPayOnline =
    (body: any) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/trxnPayOnline',
                        method: 'POST',
                        body,
                        types: [
                            TRANSACTION_PAY_ONLINE_SUCCESS,
                            TRANSACTION_PAY_ONLINE,
                            TRANSACTION_PAY_ONLINE_FAILED,
                        ],
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const getPaymentStatus =
    (body: PaymentStausApiRequestType) =>
        async (dispatch: any): Promise<PaymentStatusResponse> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/checkTrxnPaymentStatus',
                        method: 'POST',
                        body,
                        types: [
                            GET_PAYMENT_STATUS_SUCCESS,
                            GET_PAYMENT_STATUS,
                            GET_PAYMENT_STATUS_FAILED,
                        ],
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const getKycNewStatus =
    (body: PaymentStausApiRequestType) =>
        async (dispatch: any): Promise<PaymentStatusResponse> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/checkEkycNewStatus',
                        method: 'POST',
                        body,
                        types: [
                            GET_EKYC_NEW_STATUS_SUCCESS,
                            GET_EKYC_NEW_STATUS,
                            GET_EKYC_NEW_STATUS_FAILED,
                        ],
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const paywithOTM =
    (body: OtmTrxnRequestType) =>
        async (dispatch: any): Promise<ResponseBody<{ reqId: string }>> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/updateOtmTrxn',
                        method: 'POST',
                        body,
                        types: [
                            TRANSACTION_PAY_ONLINE_SUCCESS,
                            TRANSACTION_PAY_ONLINE,
                            TRANSACTION_PAY_ONLINE_FAILED,
                        ],
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const checkKYC =
    (body: any = {}) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/user/verifyKyc`,
                        method: 'POST',
                        types: [GET_KYC_VERIFIED_SUCCESS, GET_KYC_VERIFIED, GET_KYC_VERIFIED_FAILED],
                        body,
                        enableFixture: false,
                        json: `kycVerification.json`,
                        // enableForProduction:true
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const panSeedCheck =
    (body: { data: [PanSeedCheckRequestDataType] }) =>
        async (dispatch: any): Promise<{ body: PanSeedCheckResponseType }> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/user/panAadharStatus`,
                        method: 'POST',
                        types: [PAN_SEED_CHECK, PAN_SEED_CHECK_SUCCESS],
                        body,
                        enableFixture: false,
                        json: `panSeedCheck.json`,
                        // enableForProduction:true
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const checkFatca =
    () =>
        async (dispatch: any): Promise<FatcaCheckResponseType> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/user/getFatcaStatus`,
                        method: 'POST',
                        types: [GET_FATCA_STATUS_SUCCESS, GET_FATCA_STATUS, GET_FATCA_STATUS_FAILED],
                        // enableFixture: true,
                        json: `fatcaVerification.json`,
                        body: { amc: '' },
                        // enableForProduction: true
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const getAllowedBankDetails =
    (body: GetAllowedBanksRequest) =>
        async (dispatch: any): Promise<ResponseBody<OtmAllowedBankAPIResponse>> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/user/allowedBankDetails`,
                        method: 'POST',
                        types: [GET_BANK_DETAILS_SUCCESS, GET_BANK_DETAILS, GET_BANK_DETAILS_FAILED],
                        body,
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const getOtmAllowedBankDetails =
    (body: OtmAllowedBankAPIReq) =>
        async (dispatch: any): Promise<ResponseBody<OtmAllowedBankAPIResponse>> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/ft/getOtmAllowedBanks`,
                        method: 'POST',
                        types: [
                            GET_OTM_BANK_DETAILS_SUCCESS,
                            GET_OTM_BANK_DETAILS,
                            GET_OTM_BANK_DETAILS_FAILED,
                        ],
                        body: {},
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const registerNewotm =
    (body: { data: RegisterOtmReqType[] }) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: `/user/registerOtm`,
                        method: 'POST',
                        types: [REGISTER_NEW_OTM_SUCCESS, REGISTER_NEW_OTM, REGISTER_NEW_OTM_FAILED],
                        body: { ...body, reqId: '123' },
                    },
                });
            } catch (error: any) {
                throw error;
            }
        };

export const createProspectFolio =
    ({ payload, images }: { payload: NewPurchasePayload; images: any }) =>
        async (dispatch: any): Promise<any> => {
            const { newPurchase } = store.getState();
            const {
                kycVerified: { value },
            } = newPurchase;
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/prospect',
                        method: 'POST',
                        types: [PROSPECT_FOLIO_SUCCESS, PROSPECT_FOLIO],
                        body: {
                            images,
                            data: [
                                {
                                    ...payload,
                                    // kycStatus: value === null ? IsAllow.No : value
                                },
                            ],
                            reqId: '123',
                        },
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const performPennyDropValidation =
    (body: any, amc: String) =>
        async (dispatch: any): Promise<any> => {
            const { newPurchase } = store.getState();
            const {
                kycVerified: { value },
            } = newPurchase;
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/user/getPennyDropStatus',
                        method: 'POST',
                        types: [PENNY_DROP_SUCCESS, PERFORM_PENNY_DROP],
                        body: {
                            amc,
                            data: [
                                {
                                    ...body,
                                    // kycStatus: value === null ? IsAllow.No : value
                                },
                            ],
                            reqId: '123',
                        },
                        // enableFixture: true,
                        json: `pennyDropSuccess.json`,
                    },
                });
            } catch (err: any) {
                dispatch({
                    type: PENNY_DROP_SUCCESS,
                    body: {},
                });

                throw { ...err, message: 'Penny drop failed, please upload cheque!' };
            }
        };
